/// <reference path="../../Common/Base/SelectableEntityGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class SecurityMergePickerGrid extends SelectableEntityGrid<SecurityMergeRow, SecurityMergePickerOptions> {

        protected getColumnsKey() { return 'Data.SecurityMerge'; }
        protected getDialogType() { return SecurityMergeDialog; }
        protected getIdProperty() { return SecurityMergeRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityMergeRow.localTextPrefix; }
        protected getService() { return SecurityMergeService.baseUrl; }

        constructor(container: JQuery, opt: SecurityMergePickerOptions) {
            super(container, opt);
        }

        protected getColumns() {

            var columns = super.getColumns().filter(x => x.field != "ClearMatch" && x.field != "NewMatch" && x.field != "RepairMatch");

            var focusTo = Q.tryFirst(columns, x => x.field == "FocusTo");
            focusTo && SecurityMergeGrid.setupFocusToColumn(focusTo, this.view);

            return columns;
        }

        protected getInitialTitle() {
            return null;
        }

        gridPersistanceFlags() {
            var flags = super.gridPersistanceFlags();
            flags.sortColumns = false;
            return flags;
        }

        protected getPersistanceStorage() {
            return null;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != 'add-button');
            return buttons;
        }


        protected getQuickSearchFields() {
            return [
                {
                    name: 'SecurityId',
                    title: 'Security Id'
                },
                {
                    name: 'Name',
                    title: 'Name'
                },
                {
                    name: 'SecurityCode',
                    title: 'Security Code'
                },
                {
                    name: 'SourceSecurityId',
                    title: 'Source Security Id'
                },
                
                {
                    name: 'Sedol',
                    title: 'Sedol'
                },
                {
                    name: 'RIC',
                    title: 'RIC'
                },
                {
                    name: 'Isin',
                    title: 'Isin'
                },
                {
                    name: 'Cusip',
                    title: 'Cusip'
                },
                {
                    name: 'Figi',
                    title: 'Figi'
                },
                {
                    name: 'Ticker',
                    title: 'Ticker'
                }
            ]
        }

        private _criteria: any[];

        set criteria(value: any[]) {
            if (this._criteria != value) {
                this._criteria = value;
            }
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as SecurityMergeListRequest;
            if (this._criteria != null)
                request.Criteria = Serenity.Criteria.and(request.Criteria, this._criteria);

            if (this.options.repairSecurityId)
                request.RepairSecurityId = this.options.repairSecurityId;

            if (this.options.repairSourceCode != null)
                request.RepairSourceCode = this.options.repairSourceCode;

            return true;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as SecurityMergeRow;
            var target = $(e.target);

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('focus-to')) {
                    var req = this.view.params as Serenity.ListRequest;
                    if (item.SecurityId && req && req.EqualityFilter && req.EqualityFilter[SecurityMergeRow.Fields.SecurityId] == item.SecurityId)
                        this.setEquality(SecurityMergeRow.Fields.SecurityId, null);
                    else
                        this.setEquality(SecurityMergeRow.Fields.SecurityId, item.SecurityId);
                    this.refresh();

                }
            }
        }
    }
}